import React from "react";

const NumberBox = ({ onChange, value, style, disabled, required }) => {
	return (
		<input
			type="number"
			onChange={onChange}
			value={value}
			onWheel={(e) => {
        // Stop mouse wheel from changing the number
        e.preventDefault();
        e.target.blur(); // optional: removes focus so wheel won't affect it
      }}
			className={`${style} bg-transparent border p-2 text-sm rounded-md border-gray-300 cursor-pointer`}
			disabled={disabled}
			required={required}
		/>
	);
};

export default NumberBox;
